export const QUANTITIES = [20, 40, 60, 80, 100, 120, 140, 160, 180, 200, 220, 240, 260, 280, 300, 320, 340, 360, 380, 400];
export const DEFAULT_PAPER_TYPE_VALUE = 'smooth'; // use smooth as default to prevent bug with foil cards that dont have eggshell paper-type as an option
export const DEFAULT_SHAPE_VALUE = 'square';
export const COSTUMIZATION_BAR_DROPDOWN_SECTIONS = [
  { label: 'BACK', description: 'Print on the back' },
  { label: 'ENVELOPE', description: 'Print your return address' },
  { label: 'GUESTS', description: 'Add guest addressing' },
  { label: 'RSVP CARD', description: 'Add RSVP cards & envelopes' },
  { label: 'RSVP ENVELOPE', description: 'Print mailing address' },
];
export const INVITES_PRODUCT_TYPES = ['INVITATION', 'RSVP', 'SAVE_THE_DATE'];



/** WEBPACK FOOTER **
 ** ./src/constants/Cards.js
 **/